import { Check, X } from 'lucide-react';

interface YesNoButtonsProps {
  questionId: number;
  value: boolean | undefined;
  disabled: boolean;
  onChange: (value: boolean) => void;
}

const BASE = 'inline-flex h-12 min-w-[7.5rem] items-center justify-center gap-2 rounded-md border px-5 text-base font-medium '
  + 'transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-70';
const IDLE = 'border-input bg-background hover:bg-muted';

/**
 * Touch-sized Yes / No for on-site forms (Audit Lite): two large toggle
 * buttons instead of small radio dots. Behaves as a radio group.
 */
export function YesNoButtons({ questionId, value, disabled, onChange }: YesNoButtonsProps) {
  return (
    <div role="radiogroup" aria-labelledby={`question-${questionId}-label`} className="flex flex-wrap gap-3">
      <button type="button" role="radio" value="yes" aria-checked={value === true} disabled={disabled}
        onClick={() => onChange(true)}
        className={`${BASE} ${value === true ? 'border-green-600 bg-green-600 text-white hover:bg-green-600' : IDLE}`}>
        <Check className="h-5 w-5" />Yes
      </button>
      <button type="button" role="radio" value="no" aria-checked={value === false} disabled={disabled}
        onClick={() => onChange(false)}
        className={`${BASE} ${value === false ? 'border-red-600 bg-red-600 text-white hover:bg-red-600' : IDLE}`}>
        <X className="h-5 w-5" />No
      </button>
    </div>
  );
}
